import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES" />
                    <HerosectionsAll ScreenName="DISPUTE PREVENTION & RESOLUTION ADVISORY SERVICES" ScreenSearch="DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5">

                        <div className="col-12 p-lg-5 p-4 faint" style={{ textAlign: 'justify',}}>
                            <h5 className="fw-bold pb-3 gray_color">Dispute Prevention & Resolution Advisory Services</h5>
                            <ul className="ps-4">
                                <li>
                                    Assist clients in identifying situations that could lead to disputes and proactively provide advice on developing dispute prevention options. In the event of a dispute, assist Clients in early resolution through various dispute resolution methodologies, including negotiation, mediation, early neutral evaluation, adjudication, conciliation, and arbitration.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
</div>
        </>
    )
}
